import _ from 'lodash';
import { format } from 'date-fns';
import { createApiReducer } from 'src/api';

import {
  ADD_DOCUMENT_START,
  ADD_DOCUMENT_SUCCESS,
  ADD_DOCUMENT_FAILURE,
  DELETE_DOCUMENT_START,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAILURE,
  ADD_DOCUMENT_TYPE_START,
  ADD_DOCUMENT_TYPE_SUCCESS,
  ADD_DOCUMENT_TYPE_FAILURE,
  DELETE_DOCUMENT_TYPE_START,
  DELETE_DOCUMENT_TYPE_SUCCESS,
  DELETE_DOCUMENT_TYPE_FAILURE,
  EDIT_DOCUMENT_TYPE_START,
  EDIT_DOCUMENT_TYPE_SUCCESS,
  EDIT_DOCUMENT_TYPE_FAILURE,
} from './actions';

export const transformDocument = response => ({
  id: response.id,
  type: response.document_type,
  file: _.get(response, 'document_file.document_file_file'),
  title: response.document_title,
  isApproved: response.document_is_approved,
});

// on a failure document_file holds the reasons the file was refused
const transformDocumentFailure = error => {
  const response = _.get(error, 'payload.response') || {};
  return {
    ...transformDocument(response),
    file: response.document_file,
    detail: response.detail,
  };
};

export const transformDocumentType = response => ({
  id: response.id,
  name: response.document_type_type,
  description: response.document_type_description,
  frequencyType: response.document_type_upload_frequency_type || null,
  uploadDays: response.document_type_upload_frequency_days
    ? response.document_type_upload_frequency_days.toString()
    : null,
  nextUploadDate: response.document_type_next_upload_date,
  isCustom: true,
  startDate:
    format(response.document_type_next_upload_date, 'MM/DD/YYYY') || null,
  needsApproval: response.document_type_needs_approval,

  // frequencyType: 'Expiration',
});

const transformDocumentTypeFailure = error => {
  const response = _.get(error, 'payload.response') || {};
  return { ...transformDocumentType(response), detail: response.detail };
};

const updateItem = (item, key, value, newItem) => {
  if (item[key] === value) {
    return newItem;
  }
  return item;
};

const updateItems = (list, key, value, newItem) => {
  return list.map(item => {
    return updateItem(item, key, value, newItem);
  });
};
const accountAddDocumentReducer = createApiReducer(
  [ADD_DOCUMENT_START, ADD_DOCUMENT_SUCCESS, ADD_DOCUMENT_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      documents: [...state.data.documents, transformDocument(payload)],
    };
  },
  transformDocumentFailure
);

const accountDeleteDocumentReducer = createApiReducer(
  [DELETE_DOCUMENT_START, DELETE_DOCUMENT_SUCCESS, DELETE_DOCUMENT_FAILURE],
  (payload, state) => {
    return {
      ...state.data,
      documents: state.data.documents.filter(d => d.id !== payload.id),
    };
  },
  transformDocumentFailure
);

const accountAddDocumentTypeReducer = createApiReducer(
  [
    ADD_DOCUMENT_TYPE_START,
    ADD_DOCUMENT_TYPE_SUCCESS,
    ADD_DOCUMENT_TYPE_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      documentTypes: [
        ...state.data.documentTypes,
        transformDocumentType(payload),
      ],
    };
  },
  transformDocumentTypeFailure
);
const accountEditDocumentTypeReducer = createApiReducer(
  [
    EDIT_DOCUMENT_TYPE_START,
    EDIT_DOCUMENT_TYPE_SUCCESS,
    EDIT_DOCUMENT_TYPE_FAILURE,
  ],
  (payload, state) => {
    const newDocType = transformDocumentType(payload);
    return {
      ...state.data,
      documentTypes: updateItems(
        state.data.documentTypes,
        'id',
        newDocType.id,
        newDocType
      ),
    };
  },
  transformDocumentTypeFailure
);

const accountDeleteDocumentTypeReducer = createApiReducer(
  [
    DELETE_DOCUMENT_TYPE_START,
    DELETE_DOCUMENT_TYPE_SUCCESS,
    DELETE_DOCUMENT_TYPE_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      documentTypes: state.data.documentTypes.filter(d => d.id !== payload.id),
    };
  },
  transformDocumentTypeFailure
);

export const reducers = [
  accountAddDocumentReducer,
  accountDeleteDocumentReducer,
  accountAddDocumentTypeReducer,
  accountDeleteDocumentTypeReducer,
  accountEditDocumentTypeReducer,
];
